$(document).ready(function() {
    // Toggle popup when button is clicked at cart page
    $(".select-sample-btn").click(function(e) {
        e.stopPropagation(); // Prevent the event from bubbling up
        $(".sampleform_popup").toggle();
        $(".sampleform_popup").toggleClass("active");
        $("html").addClass("popup_active");
    });

    // Hide popup when clicking outside of it at cart page
    $(document).click(function(e) {
        if (!$(e.target).closest('.sampleform_popup').length && !$(e.target).closest('.select-sample-btn').length) {
            $(".sampleform_popup").removeClass("active").hide();
            $("html").removeClass("popup_active");
          
        }
    });

  $(".pop-header-cross").click(function(){
     $(".sampleform_popup").removeClass("active").hide();
            $("html").removeClass("popup_active");
});


   let itemsToAdd = [];
let itemsToRemove = [];

  $('input[name="sample-products"]').on('change', function() {
    const variantId = parseInt($(this).val());

    if ($(this).is(':checked')) {
        // If checked, add to itemsToAdd and remove from itemsToRemove if it exists
        itemsToAdd.push({ id: variantId, quantity: 1 });
        itemsToRemove = itemsToRemove.filter(item => item.id !== variantId);
    } else {
        // If unchecked, add to itemsToRemove and remove from itemsToAdd if it exists
        itemsToRemove.push({ id: variantId, quantity: 0 });
        itemsToAdd = itemsToAdd.filter(item => item.id !== variantId);
    }
});

  $('body').on('click', '.confirm-btn', function(){
    $(".sampleform_popup .loading__spinner").removeClass("hidden");

    if (itemsToAdd.length > 0) {
            ajax_AddToCart(itemsToAdd, 0);
        }

     if (itemsToRemove.length > 0) {
            ajax_RemoveFromCart(itemsToRemove, 0);
        }

  });



  function ajax_RemoveFromCart(itemsToRemove, itemIndex) {
          console.log('remove', itemsToRemove + itemIndex);
            jQuery.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: itemsToRemove[itemIndex],
                dataType: 'json',
                success: function() {
                    itemIndex += 1;
                    if(itemIndex < itemsToRemove.length){
                      ajax_RemoveFromCart(itemsToRemove, itemIndex)
                    } else{
                     // location.href = "/cart"
                      refreshCartItems();
                    }
                },
                 error: function(xhr, status, error) {
                   var err_message = JSON.parse(xhr.responseText);
                  console.log(err_message.message);// Logs the response body in case of error
                  itemIndex += 1;
                    if(itemIndex < itemsToRemove.length){
                      ajax_RemoveFromCart(itemsToRemove, itemIndex)
                    } else{
                     // location.href = "/cart"
                      refreshCartItems();
                    }
    }
            });
        }
  
  function ajax_AddToCart(itemsToAdd, itemIndex){
  console.log('adddd', itemsToAdd + itemIndex);
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: itemsToAdd[itemIndex],
              dataType: 'json',
              success: function() {
                 console.log("success", itemIndex)
                    itemIndex += 1;
                    if(itemIndex < itemsToAdd.length){
                      ajax_AddToCart(itemsToAdd, itemIndex)
                    } else{
                     // location.href = "/cart"
                      refreshCartItems();
                    }
              },
                error: function(xhr, status, error) {
                   var err_message = JSON.parse(xhr.responseText);
                  console.log(err_message.message);// Logs the response body in case of error
                  itemIndex += 1;
                  console.log("error", itemIndex);
                    if(itemIndex < itemsToAdd.length){
                      ajax_AddToCart(itemsToAdd, itemIndex)
                    } else{
                     // location.href = "/cart"
                      refreshCartItems();
                    }
    }
            });

        }

 /*$('body').on('click', '.confirm-btn', function(){
   $(".confirm-btn .loading__spinner").removeClass("hidden");
    var formData = { 'items': []  };
    $('input[name="sample-products"]:checked').each(function() { 
      if($(this).hasClass("not_added")){
    formData.items.push({
                 'id': parseInt($(this).val()),
                 'quantity': 1
             });
      }
        });

   var removeformData = { 'items': []  };
   $('input[name="sample-products"]:not(:checked)').each(function() {
    if ($(this).hasClass("added")) {
        // You can push the values of unchecked checkboxes here
        removeformData.items.push({
            'id': parseInt($(this).val()),
            'quantity': 0
        });
    }
});

       if (!$.isEmptyObject(removeformData)) {
    // Iterate over the "items" array using jQuery's $.each() function
    $.each(removeformData.items, function(index, item) {
        console.log("Item ID: " + item.id + ", Quantity: " + item.quantity);
      //remove_to_cart_grid(item.id);
       removeItemsSequentially(removeformData.items);
    });
}


console.log('formData', formData);
   
console.log('removed',removeformData);

 if (formData.items.length > 0) {
     console.log('formData.length');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json', 
            success: function (data) {
              // console.log("first");
              console.log(data);
              // console.log("last");
             // refreshCartItems();
console.log("in success");

          
              
                const intervalId = setInterval(function() {
                $('cart-drawer').removeClass('active');
                  $("body").removeClass("overflow-hidden"); 
                }, 50);
                
                // Stop the interval after 3 seconds
                setTimeout(function() {
                clearInterval(intervalId);
                }, 4000);},
         error: function(xhr, status, error) {
           console.log("in errors");
        // Enhanced error logging
        console.error('Error adding item to cart:');
        console.error('Status:', status);
        console.error('Error:', error);
        console.error('Response:', xhr.responseText);  // Logs the response body in case of error
    }
        
        });

   

 }

 });*/

  function removeItemsSequentially(items) {
    // If there are no items left to remove, stop the process
    if (items.length === 0) {
        console.log("All items removed from cart.");
        return;
    }

    // Get the first item to remove
    const item = items[0];
    console.log("Removing Item ID: " + item.id + ", Quantity: " + item.quantity);

    // Call the remove function for this item
    remove_to_cart_grid(item.id, function() {
        // Once the item is removed, call the function again with the remaining items
        removeItemsSequentially(items.slice(1));
    });
}

 function refreshCartItems(){

    fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-items'];
            
            for (const selector of selectors) {
              const added_prod = document.getElementsByClassName("added-sample-product-area");
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);      
              const sourcesection = html.querySelector(".sample-sec"); 
const addedProds = document.getElementsByClassName("added-sample-product-area");
const sourceTable = html.querySelector("table");   

if (sourcesection) {
  const sourceHTML = sourcesection.outerHTML; // Get the HTML string of the element
  
  // Loop through each added product area
  Array.from(addedProds).forEach((added_prod) => {
    added_prod.innerHTML = sourceHTML; // Set innerHTML for each element
    $(".sampleform_popup").removeClass("active").hide();
            $("html").removeClass("popup_active"); 
            $("body").removeClass("overflow-hidden"); 
   $(".sampleform_popup .loading__spinner").addClass("hidden");
   $(".quick-add-button-cart .loading__spinner").addClass("hidden");
    
    
    
  });
}

              // console.log(sourcesection);
              
              
              $('cart-drawer').removeClass('active');
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);

                var total_sample_added_count =  $(".added-sample-product-area .sample-sec ul li").length;
  if(total_sample_added_count > 0)
  {
    $(".added-item-count-text").text(`Deluxe sample(s) has been added to your order`);
 //    if(total_sample_added_count > 1){
 // $(".added-item-count-text").text(`${total_sample_added_count} samples are added in cart`);
 //    } else
 //    {
 //     $(".added-item-count-text").text(`${total_sample_added_count} sample are added in cart`); 
 //    }
    
  }
                 setTimeout(function() {
                  var total_count_Cart = $("cart-items").attr("data-cart_total");
                $(".cart__footer .totals__subtotal-value").text(total_count_Cart);
                }, 1000);
                
              }
            }
             
            
            
          })
          .catch((e) => {
            console.error(e);
          });
  }


  function remove_to_cart_grid(variantid) {
    var id = variantid;
    var ajax = {
      type: "POST",
      url: "/cart/change.js",
      data: {
        quantity: 0, // Setting quantity to 0 to remove the item
        id: id      // Variant ID of the item to remove
      },
      dataType: "json",
      success: function (response) {
        refreshCartItems(); 
        console.log('Item removed from the cart.dd');
      },
      error: function (error) {
         console.log('Failed to remove item:', error);
      }
    };
    jQuery.ajax(ajax);
}
      



// $(".quick-add-button-cart").click(function() {
   $('body').on('click', '.quick-add-button-cart', function(){
   $(this).find(".loading__spinner").removeClass("hidden");
    var recommended_id = $(this).attr("data-cart_prod");
    console.log(recommended_id);  // Log recommended_id instead of vall

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: parseInt(recommended_id),
            quantity: 1
        },
        dataType: 'json',
        success: function(data) {
            console.log(data);  // Log the response data from the server
          refreshCartItems();
        },
        error: function(xhr) {
            console.error('Error:', xhr);  // Log the error to the console
        }
    });
});



  // autoplay video text autotype
const video = document.querySelector(".hp-video");
var fir_txt = $(".first-text").text().trim();
var sec_txt = $(".second-text").text().trim();

$(".html-heading").attr("first-text", fir_txt);
$(".html-heading").attr("second-text", sec_txt);

let isTypingFirst = false;  // Flag for first text
let isTypingSecond = false; // Flag for second text

// function typeText(targetClass, text, onComplete) {
//     $(targetClass).text(''); // Clear text
//     let index = 0; // Reset index

//     function type() {
//         if (index < text.length) {
//             document.querySelector(targetClass).innerHTML += text.charAt(index);
//             index++;
//             setTimeout(type, 100); // Typing speed
//         } else {
//             if (onComplete) onComplete(); // Reset flag after completion
//         }
//     }

//     type();
// }

  function typeText(targetClass, text, onComplete) {
    const target = document.querySelector(targetClass);
    
    // Ensure the target starts empty before adding spans
    target.innerHTML = '';

    // Wrap each character in a span with visibility: hidden
    text.split('').forEach(char => {
        let span = document.createElement("span");
        span.style.visibility = "hidden";
        span.textContent = char;
        target.appendChild(span);
    });

    let index = 0;

    function type() {
        if (index < text.length) {
            target.children[index].style.visibility = 'visible'; // Reveal each letter one by one
            index++;
            setTimeout(type, 100); // Adjust typing speed
        } else {
            if (onComplete) onComplete(); // Callback after typing completes
        }
    }

    // Keep all letters hidden for 1 second, then start typing
    setTimeout(() => {
        type();
    }, 1000);
}

video.addEventListener("timeupdate", () => {
    const currentTime = Math.floor(video.currentTime);

    // Typing first-text at 1s and 12s
    if ((currentTime === 1 || currentTime === 12) && !isTypingFirst) {
        isTypingFirst = true;
        
        // Hide second-text at the same time first-text hides
        $(".second-text span").css("visibility", "hidden");

        typeText(".first-text", $(".html-heading").attr("first-text"), () => {
            isTypingFirst = false; // Reset after typing completes
        });
    }

    // Typing second-text at 2s and 13s
    if ((currentTime === 2 || currentTime === 13) && !isTypingSecond) {
        isTypingSecond = true;
        
        typeText(".second-text", $(".html-heading").attr("second-text"), () => {
            isTypingSecond = false; // Reset after typing completes
        });
    }
});


});